import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { BaseBillingDialog } from '../base-billing-dialog';
import { TabItem } from '@components/tabs/tab-item.interface';
import { BillingService } from '@features/billing/billing.service';
import { DialogRef } from '@components/dialog/dialog-ref';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastService } from '@core/state/toast/toast.service';
import { BillingDetailRequest } from '@core/models/billing/billing-detail-request';
import { $log } from '@core/utils/logger';
import { pickClass } from '@core/utils/object';

@Component({
    selector: 'ihd-dialog-billing-details',
    templateUrl: 'billing-details.component.html',
    styleUrls: ['billing-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'c-dialog-billing-details'
    },
})
export class DialogBillingDetailsComponent extends BaseBillingDialog implements OnInit, OnDestroy {
    public config: any;
    public tabItems: TabItem[];

    constructor(
        billingService: BillingService,
        cdr: ChangeDetectorRef,
        toastService: ToastService,
        //intercomService: IntercomService,
        sanitizer: DomSanitizer,
        translateService: TranslateService,
        private dialogRef: DialogRef<DialogBillingDetailsComponent>
    ) {
        super(
            billingService,
            toastService,
            //intercomService,
            sanitizer,
            translateService,
            cdr
        );
        this.config = dialogRef.containerInstance.config;
        this.tabItems = [
            {
                label: 'Billing.Details.Address.Title',
                active: true,
            },
        ];
        this.createForm();
    }

    ngOnInit() {
        // Define existing billing details
        const billingDetails: BillingDetailRequest = pickClass(
            this.config.billingDetails || {},
            BillingDetailRequest
        );
        this.origValue = billingDetails;
        this.billingForm.patchValue(billingDetails);
        this.cdr.markForCheck();
    }

    ngOnDestroy() {
        this.destroy();
    }

    closeDialog() {
        this.dialogRef.close();
    }

    /**
     * Save billing details.
     */
    submit() {
        this.isSubmitted = true;
        this.cdr.markForCheck();

        if (this.billingForm.valid) {
            const billingInfo = this.billingForm.value;
            this.isLoading = true;
            this.cdr.markForCheck();

            this.billingService.updateBilling(billingInfo).subscribe(
                (response) => {
                    this.dialogRef.close({ success: true, response });
                },
                (response) => {
                    // ERROR: Update failed.
                    // Define payment gateway error as required
                    let billingError: any;
                    try {
                        billingError = JSON.parse(
                            response.payload.error.message
                        );
                    } catch (e) {
                        billingError = response.payload.error;
                    }

                    $log.error(
                        'Billing update failed:',
                        response.payload.error
                    );
                    this.toastService.showError(billingError.message);
                    this.isLoading = false;
                    this.cdr.markForCheck();
                }
            );
        }
    }
}
